import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	yAxis: {
		id: 'software-deployment-frequency-report.batch-size-chart.chart.y-axis',
		defaultMessage: 'Batch size (issues per deployment)',
		description: 'Label for the chart y-axis',
	},
	yAxisIssueTermRefresh: {
		id: 'software-deployment-frequency-report.batch-size-chart.chart.y-axis-issue-term-refresh',
		defaultMessage: 'Batch size (work items per deployment)',
		description: 'Label for the chart y-axis',
	},
});
